import { SkillsSaveVO } from '@domain/rq/profile/ProfileProjectListSaveRq';
import { ProfileProjectVO, SkillsVO } from '@domain/vo/profile/ProfileProjectVO';
import { ReactSelectOption } from '@domain/constant/ReactSelectOption';
import { ProjectType } from '@domain/constant/profile/ProjectType';
import DateFormat from '@utils/date/format';

export class ProfileProjectFormVO {
  title: string;
  startDate?: string;
  endDate?: string;
  teamType: ProjectType | null;
  contribution: ReactSelectOption<number> | null;
  performance: string;
  institution: string;
  skills: SkillsVO[] | [];

  constructor(dto: ProfileProjectVO) {
    this.title = dto.title;
    this.startDate = DateFormat.getDateFormatString(dto.startDate, 'yyyy-MM');
    this.endDate = DateFormat.getDateFormatString(dto.endDate, 'yyyy-MM');
    this.teamType = dto.teamType;
    this.contribution = ProfileProjectFormVO.getContributionFormat(dto.contribution);
    this.performance = dto.performance;
    this.institution = dto.institution;
    this.skills = dto?.skills;
  }

  static getContributionFormat(contribution: number | null) {
    if (!contribution) return null;
    return { value: contribution, label: `${contribution}%` };
  }

  static convertProfileProjectSaveVO(vo: ProfileProjectFormVO) {
    return {
      title: vo.title,
      startDate: vo.startDate,
      endDate: vo.endDate,
      teamType: vo.teamType,
      contribution: vo.contribution ? vo.contribution.value : null,
      performance: vo.performance,
      institution: vo.institution,
      skills: vo.skills?.map((skill) => new SkillsSaveVO(skill)) || [],
    };
  }
}
